export default from './ResetPasswordForm';



// WEBPACK FOOTER //
// ./src/sharedComponents/ResetPasswordForm/index.js